// extracted by mini-css-extract-plugin
export default {"notification":"ADtzOx","image":"BZUvZW"};